module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Readers love")]), _vm._v(" "), _c('span', {
    staticClass: "t2"
  }, [_vm._v("Rescuing Jack")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("by")]), _vm._v(" "), _c('span', {
    staticClass: "t3"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "t4"
  }, [_vm._v("AITLIN")]), _vm._v(" "), _c('span', {
    staticClass: "t3"
  }, [_vm._v("R")]), _c('span', {
    staticClass: "t4"
  }, [_vm._v("ICCI")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“…I can tell that Caitlin Ricci must be an animal lover, it was definitely written with a lot of love and affinity for pets.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—Hearts on Fire")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“…a refreshing new way to write about shifters, and a very true look at those who love animals, support adoption through rescue shelters, and believe we all deserve healing hearts and second chances”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—MM Good Book Reviews")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“Thank you, Caitlin, for a beautiful story of pain, fear, terror, drama, hope, love, family, and the love of a dog.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—Rainbow Book Reviews")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“I loved the book… I believe Caitlin Ricci has the beginnings of a wonderful series here.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—The Novel Approach")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“"), _c('span', {
    staticClass: "t6"
  }, [_vm._v("Rescuing Jack")]), _vm._v(" is a great starting point for someone thinking about dipping their feet into this genre. The author is one that will pull you in with her story telling…”")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("—Top 2 Bottom Reviews")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47993f62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/002.vue
// module id = 57
// module chunks = 0